/** @file pastedPng: the PNG a paste event carries (a copied image or file), as bytes. */

/** The first `image/png` file or item of the event's clipboard data; null when it holds none. */
export async function pastedPng(e: Pick<ClipboardEvent, 'clipboardData'>): Promise<Uint8Array | null> {
  const data = e.clipboardData;
  if (data === null) return null;
  const file = Array.from(data.files).find((f) => f.type === 'image/png')
    ?? Array.from(data.items).find((i) => i.kind === 'file' && i.type === 'image/png')?.getAsFile() ?? null;
  return file === null ? null : new Uint8Array(await file.arrayBuffer());
}
